import React from 'react';
import types from '../../types';
import logo from '../../assets/logo.png';
import styles from './styles.module.scss';

const ContainerContent = ({children}) => (
  <div className={styles.contentContainer}>
    {children}
  </div>
);

ContainerContent.propTypes = {
  ...types.children,
};

export default ContainerContent;
